import {useEffect} from 'react';
import {SubmitHandler, UseFormReturn} from 'react-hook-form';
import {Observable} from 'rxjs';
import {filter} from 'rxjs/operators';


export type UseFormSubmissionSignalHookOption<T> = {
    doItPlease$: Observable<boolean>;
    submit: SubmitHandler<T>;
    useFormResult: UseFormReturn<T>;
};
export const useFormSubmissionSignal$ = <T>({
                                                doItPlease$,
                                                submit,
                                                useFormResult,
                                            }: UseFormSubmissionSignalHookOption<T>
) => {
    const validatedSubmit = useFormResult.handleSubmit(submit);
    useEffect(() => {
        const subscription = doItPlease$
            .pipe(
                filter(now => now),
            )
            .subscribe(() => validatedSubmit());
        return () => {
            subscription.unsubscribe();
        };
    }, [doItPlease$, validatedSubmit]);
}
